<div class="row">
    <div class="col-md-12">
        <app-util-visitor-parts-medical-consultation-list-filter
                                            [selfVisitor]="selfVisitor"
                                            (filterEvent)="filterVisitorMedicalConsultations($event)"></app-util-visitor-parts-medical-consultation-list-filter>
    </div>
</div>
<div class="row mt-5">
    <div class="col-md-12 align-items-center justify-content-space-between">
        <h5 class="title mb-3">
            <ng-container *ngIf="selfVisitor">
                {{ 'VISITORS_MEDICAL.VISITOR_MEDICAL_CONSULTATIONS' | translate }}
            </ng-container>
            <ng-container *ngIf="!selfVisitor">
                {{ 'VISITORS_MEDICAL.VISITORS_MEDICAL_CONSULTATIONS' | translate }}
            </ng-container>
        </h5>
        <button type="button"
                class="btn btn-primary btn-fill"
                (click)="utilVisitorPartsMedicalConsultationModalsAdd.openModal(visitor?.id)"
                *ngxPermissionsOnly="'cudVisitorMedicalConsultation'">
            <i class="fa fa-plus"></i> {{ 'VISITORS_MEDICAL.ADD_MEDICAL_CONSULTATION' | translate }}
        </button>
    </div>
</div>
<div class="row mt-3">
    <div class="col-md-12">
        <ng-container *ngIf="!isLoading">
            <ng-container *ngIf="hasData?.visitorMedicalConsultations">
                <div class="overflow-auto pb-3">
                    <table class="table table-condensend table-striped">
                        <thead>
                            <tr>
                                <th class="p-3 text-center-important">#</th>
                                <th class="p-3 text-center-important"
                                    *ngxPermissionsOnly="'cudVisitorMedicalConsultation'">{{ 'SHARED.ACTIONS' | translate }}</th>
                                <th class="p-3 text-center-important">{{ 'VISITORS_MEDICAL.DATE' | translate }}</th>
                                <ng-container *ngIf="!selfVisitor">
                                    <th class="p-3 text-center-important">{{ 'VISITORS_MEDICAL.VISITOR' | translate }}</th>
                                </ng-container>
                                <th class="p-3 text-center-important">{{ 'VISITORS_MEDICAL.DOCTOR' | translate }}</th>
                                <th class="p-3 text-center-important">{{ 'VISITORS_MEDICAL.SPECIALITY' | translate }}</th>
                                <th class="p-3 text-center-important">{{ 'VISITORS_MEDICAL.REMARKS' | translate }}</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let visitorMedicalConsultation of visitorMedicalConsultations?.data; let i = index">
                                <td class="p-3 text-center-important">{{ i + 1 }}</td>
                                <td class="p-3 text-center-important td-actions"
                                    *ngxPermissionsOnly="'cudVisitorMedicalConsultation'">
                                    <button type="button"
                                            class="btn btn-success btn-simple p-0"
                                            title="{{ 'VISITORS_MEDICAL.EDIT_MEDICAL_CONSULTATION' | translate }}"
                                            (click)="utilVisitorPartsMedicalConsultationModalsAdd.openModal(visitor?.id, visitorMedicalConsultation)"
                                            appTooltip>
                                        <i class="fa fa-edit"></i>
                                    </button>
                                    <button type="button"
                                            class="btn btn-danger btn-simple ml-3 p-0"
                                            title="{{ 'VISITORS_MEDICAL.DELETE_MEDICAL_CONSULTATION' | translate }}"
                                            (click)="delete(visitorMedicalConsultation)"
                                            appTooltip>
                                        <i class="fa fa-trash"></i>
                                    </button>
                                </td>
                                <td class="p-3 text-center-important">{{ visitorMedicalConsultation?.date | localizedDate: true | ifEmpty: '-' }}</td>
                                <ng-container *ngIf="!selfVisitor">
                                    <td class="p-3 text-center-important">
                                        <a [routerLink]="['/visitor', visitorMedicalConsultation?.vId, 'infirmary', 'medical-consultations']"
                                            class="text-primary">
                                            {{ visitorMedicalConsultation?.showName }}
                                        </a>
                                    </td>
                                </ng-container>
                                <td class="p-3 text-center-important">
                                    {{ visitorMedicalConsultation?.doctor | ifEmpty: '-' }}
                                </td>
                                <td class="p-3 text-center-important">
                                    {{ visitorMedicalConsultation?.speciality | ifEmpty: '-' }}
                                </td>
                                <td class="p-3 text-center-important">
                                    <app-text-limit [text]="visitorMedicalConsultation?.remarks" [title]="'REMARK'"></app-text-limit>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                    <div class="align-items-center justify-content-center" *ngIf="visitorMedicalConsultations?.last_page > 1">
                        <app-pagination [data]="visitorMedicalConsultations" (switchPage)="switchPage($event)"></app-pagination>
                    </div>
                </div>
            </ng-container>
            <ng-container *ngIf="!hasData?.visitorMedicalConsultations">
                <p>
                    <ng-container *ngIf="selfVisitor">
                        {{ 'VISITORS_MEDICAL.NO_VISITOR_MEDICAL_CONSULTATION_FOUND' | translate }}
                    </ng-container>
                    <ng-container *ngIf="!selfVisitor">
                        {{ 'VISITORS_MEDICAL.NO_VISITORS_MEDICAL_CONSULTATION_FOUND' | translate }}
                    </ng-container>
                </p>
            </ng-container>
        </ng-container>
        <ng-container *ngIf="isLoading">
            <p>
                <app-loading-spinner></app-loading-spinner>
            </p>
        </ng-container>
    </div>
</div>
<app-util-visitor-parts-medical-consultation-modals-add (addMedicalConsultationEvent)="addMedicalConsultation()" #utilVisitorPartsMedicalConsultationModalsAdd></app-util-visitor-parts-medical-consultation-modals-add>